export interface BlindBoxGiftItem {
  is_blind_box_gift?: number | string;
  product_sale_type?: number | string;
  type?: number | string;
  shop_sku?: string;
}

export function hasBlindBoxGiftFlag(item: BlindBoxGiftItem | null | undefined): boolean {
  return Number(item?.is_blind_box_gift) === 1;
}

/**
 * A blind-box gift must be both a gift line and explicitly marked by the API.
 * Pricing cart lines use `type`; persisted order lines use `product_sale_type`.
 */
export function isBlindBoxGift(item: BlindBoxGiftItem | null | undefined): boolean {
  if (!hasBlindBoxGiftFlag(item)) return false;

  return Number(item.type) === 4 || Number(item.product_sale_type) === 4;
}

export function getOrderItemDisplay(item: BlindBoxGiftItem | null | undefined) {
  const isAccessoryDisplay = isBlindBoxGift(item);

  return {
    isAccessoryDisplay,
    canNavigate: !isAccessoryDisplay,
  };
}

export function getOrderItemNavigation(item: BlindBoxGiftItem | null | undefined) {
  if (!getOrderItemDisplay(item).canNavigate || !item?.shop_sku) return undefined;

  return { href: `/goods-detail/${item.shop_sku}` };
}
